import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

export const MessagePopUp = (props) => {
  const {
    conformation,
    cancel,
    openPopUp,
    message,
    hideCancel = true,
    hideOk = true
  } = props;

  return (
    <Dialog open={openPopUp} onClose={cancel}>
      <DialogTitle>
        <Typography variant="h4">Confirm?</Typography>
      </DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        {hideCancel && (
          <Button onClick={cancel} >
            Cancel
          </Button>
        )}
        {hideOk && (
          <Button 
            onClick={conformation} 
            variant="contained" 
            sx={{
              backgroundColor: '#fa0707ff', 
              '&:hover': {
                backgroundColor: '#e71414ff',
              }
            }}
          >
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};